/*
 * Corrige el salto a un ancla en las paginas de politicas (AGB, Datenschutz…).
 *
 * El navegador salta al ancla en cuanto encuentra el elemento, y en ese momento el
 * tema todavia no ha medido el header sticky: `--header-height` vale 0px, asi que el
 * `scroll-margin` de `.rte :target` (ver theme.css) se queda corto y el titulo enlazado
 * acaba tapado por el header.
 *
 * Basta con repetir el scroll una vez el header ya tiene altura real. `scrollIntoView`
 * respeta `scroll-margin`, asi que el desplazamiento correcto sigue viviendo en el CSS.
 *
 * Solo actua en la carga inicial y solo si la URL trae hash; los clicks en anclas dentro
 * de una pagina ya cargada no lo necesitan, porque para entonces la medida ya es buena.
 */
(() => {
  if (!window.location.hash) return;

  const target = () => {
    try {
      return document.querySelector(window.location.hash);
    } catch {
      return null; // hash que no es un selector valido
    }
  };

  const realign = () => {
    const el = target();
    if (el) el.scrollIntoView();
  };

  // Doble rAF: el primero espera al pintado, el segundo a que el custom element del
  // header haya escrito --header-height.
  window.addEventListener('load', () => {
    requestAnimationFrame(() => requestAnimationFrame(realign));
  });
})();
